import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  search: "",
};

const blogFilterSlice = createSlice({
  name: "blogFilter",
  initialState,
  reducers: {
    // ✅ Only update status
    setBlogStatus: (state, action) => {
      state.status = action.payload ?? null;
    },

    // ✅ Only update search text
    setBlogSearch: (state, action) => {
      state.search = action.payload ?? "";
    },

    // ✅ Reset all filters
    clearBlogFilters: () => initialState,
  },
});

export const {
  setBlogStatus,
  setBlogSearch,
  clearBlogFilters,
} = blogFilterSlice.actions;

export const selectBlogFilter = (state) => state.blogFilter;
export const selectBlogSearch = (state) => state.blogFilter.search;
export const selectBlogStatus = (state) => state.blogFilter.status;

export default blogFilterSlice.reducer;
